import { $createParagraphNode, $getRoot, createEditor } from 'lexical';
/**
 * Creates the `SerializedEditorState` a controlled Composer emits when its
 * editor is empty — an empty paragraph under the Lexical root.
 *
 * Consumers that need to compare their controlled `value` against the
 * "editor is blank" state should use this helper rather than
 * hand-writing the root/paragraph shape, so future changes to Lexical's
 * serialized blank-state (`version` bumps, added fields, node config
 * changes) do not require every consumer to re-mirror the SDK's internals.
 *
 * @example
 * ```tsx
 * const emptyValue = createEmptyComposerValue(nodes);
 * const [value, setValue] = useState<SerializedEditorState>(emptyValue);
 * <Composer value={value} onValueChange={setValue} />
 * ```
 */
export const createEmptyComposerValue = (nodes) => {
    const editor = createEditor({ nodes, onError: () => { } });
    // Mirrors LexicalComposer's own initialization: a fresh EditorState's root
    // has no children until an update appends the empty paragraph.
    editor.update(() => {
        $getRoot().append($createParagraphNode());
    }, { discrete: true });
    return editor.getEditorState().toJSON();
};
//# sourceMappingURL=emptyValue.js.map